<template>
  <div
    v-if="enabled && logos.length"
    style="background: #0A0E1B;margin-left:-25px;margin-right:-14px;padding-top:25px;"
  >
    <h5 class="text-center text-muted">Parceiros</h5>
    <div class="scrolling-logos">
      <div class="logos-slide">
        <img
          v-for="(logo, index) in duplicatedLogos"
          :key="index"
          class="m-4 partner-logo"
          :src="logo.src"
          :alt="logo.alt"
          @error="onImgError"
        />
      </div>
    </div>
  </div>
</template>

<script>
// Itens padrão exibidos caso a API de Seções (gerenciador > Personalizar >
// Seções) esteja indisponível - idênticos ao que já estava fixo no site.
const FALLBACK_LOGOS = [
  { src: "/assets/huawei.png", alt: "Logo Huawei" },
  { src: "/assets/ubiquiti.png", alt: "Logo Ubiquiti" },
  { src: "/assets/cisco.png", alt: "Logo Cisco" },
  { src: "/assets/Connection.png", alt: "Logo Connection" },
];

export default {
  name: "CarrouselParceiros",
  data() {
    return {
      logos: FALLBACK_LOGOS,
      enabled: true,
    };
  },
  mounted() {
    this.loadParceiros();
  },
  computed: {
    // Duplica o conjunto de logos uma vez: o trilho fica com 2x o
    // conteúdo e a animação desloca -50% (metade do trilho), criando
    // um loop contínuo e imperceptível independente da largura exata
    // de cada logo.
    duplicatedLogos() {
      return [...this.logos, ...this.logos];
    },
  },
  methods: {
    async loadParceiros() {
      try {
        const response = await fetch(
          "/api/sync_ecommerce_sections.php?secao=parceiros"
        );
        const data = await response.json();
        if (data && data.status === "success") {
          this.enabled = data.enabled !== false;
          if (Array.isArray(data.itens) && data.itens.length) {
            this.logos = data.itens.map((item) => ({
              src: item.image,
              alt: "Logo " + (item.name || "Parceiro"),
            }));
          }
        }
      } catch (error) {
        console.error("Erro ao carregar seção de Parceiros:", error);
        // mantém os logos padrão (FALLBACK_LOGOS) já definidos em data()
      }
    },
    onImgError(event) {
      // Evita ícone de "imagem quebrada" caso uma logomarca configurada no
      // gerenciador ainda não tenha sido enviada/publicada corretamente.
      event.target.style.display = "none";
    },
  },
};
</script>

<style scoped lang="scss">
/* 1. Container Principal: Centraliza e oculta o que está fora. */
.scrolling-logos {
  overflow: hidden;
  margin: 0 auto;
  max-width: 90vw;
  white-space: nowrap;
  padding: 20px 0;
}

/* 2. Slider/Trilho: Contém os logos (2 conjuntos) e é o elemento animado.
   width: max-content faz o trilho ter exatamente a largura da soma dos
   logos, então translateX(-50%) sempre desloca por um conjunto inteiro,
   sem depender de cálculo de pixels fixos. */
.logos-slide {
  display: flex;
  flex-wrap: nowrap;
  width: max-content;
  animation: scrollInfinito 30s linear infinite;
  transition: opacity 0.3s ease-in-out;
}

/* 3. Logos Individuais (com efeitos de hover) */
.partner-logo {
  object-fit: contain;
  width: 180px;
  height: 50px;
  opacity: 0.8;
  flex-shrink: 0;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}

.partner-logo:hover {
  transform: scale(1.1);
  opacity: 1;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}

/* Efeito Bônus: Pausar a animação no hover */
.scrolling-logos:hover .logos-slide {
  animation-play-state: paused;
}

@keyframes scrollInfinito {
  0% {
    transform: translateX(0);
  }
  100% {
    /* Desloca exatamente metade do trilho (um conjunto de logos),
       já que o trilho contém 2 conjuntos duplicados. */
    transform: translateX(-50%);
  }
}

/* Ajuste para telas menores */
@media (max-width: 768px) {
  .partner-logo {
    width: 120px !important;
    height: 50px !important;
    margin: 10px !important;
  }
}
</style>
